import { css, styled } from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';
import type { TCardMode } from '@/modules/game/types';
import { device } from '@/styles/helpers';

const bgSrc = getCDNImageUrl('/lobbySpins.webp');

interface IScShowAllGameCardProps {
  mode: TCardMode;
  isSmall: boolean;
}

export const ScShowAllGameCard = styled.div<IScShowAllGameCardProps>`
  container-type: inline-size;
  container-name: show-all-game-card;
  display: flex;
  width: 100%;
  height: calc(100% - 41px);
  padding: 0px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 12px;
  background: url(${bgSrc}) center no-repeat;

  &.black {
    background-color: ${({ theme }) => theme.blackColor};
  }

  &.dark {
    background-color: ${({ theme }) => theme.grayDarkColor};
  }

  &.light {
    background-color: ${({ theme }) => theme.gray1Color};
  }

  & button {
    ${({ isSmall }) =>
      isSmall
        ? css`
            min-width: auto;
            padding: 0;
            border: none;
          `
        : css`
            min-width: 100%;
          `}
  }

  @media (${device.tablet}) {
    min-width: 101px;
    height: calc(100% - 36px);
    > a {
      width: 100%;
    }
    padding: 0 8px;
    & button {
      padding: 0px 11px 1px 11px;
    }
  }
`;
